define.alias("shared/components/shared/post/secondary/caption-writer/landing-card", "media/components/shared/post/secondary/caption-writer/landing-card");